/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Receivelist_News1Inputs */

const id_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berita dan pembaruan Epic Games Store`)
};

const ms_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berita dan kemas kini Epic Games Store`)
};

const da_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store nyheder og opdateringer`)
};

const de_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store Nachrichten und Updates`)
};

const en_us2_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store news and updates`)
};

const es_es2_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noticias y actualizaciones de la Epic Games Store`)
};

const es_mx2_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noticias y actualizaciones de la Epic Games Store`)
};

const fil_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balita at update ng Epic Games Store`)
};

const fr_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualités et mises à jour de l'Epic Games Store`)
};

const it_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizie e aggiornamenti dell'Epic Games Store`)
};

const hu_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store hírek és frissítések`)
};

const nl_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store nieuws en updates`)
};

const no_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store-nyheter og oppdateringer`)
};

const pl_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiadomości i aktualizacje Epic Games Store`)
};

const pt_br2_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notícias e atualizações de Epic Games Store`)
};

const pt_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notícias e atualizações da Epic Games Store`)
};

const ro_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Știri și actualizări Epic Games Store`)
};

const fi_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Storen uutiset ja päivitykset`)
};

const sv_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyheter och uppdateringar om Epic Games Store`)
};

const vi_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tin tức và cập nhật Epic Games Store`)
};

const tr_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store haberleri ve güncellemeleri`)
};

const cs_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novinky a aktualizace Epic Games Store`)
};

const bg_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новини и актуализации на Epic Games Store`)
};

const ru_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новости и обновления Epic Games Store`)
};

const uk_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новини та оновлення Epic Games Store`)
};

const ar_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أخبار وتحديثات Epic Games Store`)
};

const hi_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store समाचार और अपडेट`)
};

const th_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข่าวสารและอัปเดต Epic Games Store`)
};

const ja_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store のニュースと更新`)
};

const zh_cn2_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic游戏商城新闻和更新`)
};

const zh_hant1_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic遊戲商城新聞和更新`)
};

const ko_notifications_receivelist_news1 = /** @type {(inputs: Notifications_Receivelist_News1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store 뉴스 및 업데이트`)
};

/**
* | output |
* | --- |
* | "Epic Games Store news and updates" |
*
* @param {Notifications_Receivelist_News1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_receivelist_news1 = /** @type {((inputs?: Notifications_Receivelist_News1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Receivelist_News1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_receivelist_news1(inputs)
	if (locale === "ms") return ms_notifications_receivelist_news1(inputs)
	if (locale === "da") return da_notifications_receivelist_news1(inputs)
	if (locale === "de") return de_notifications_receivelist_news1(inputs)
	if (locale === "en-US") return en_us2_notifications_receivelist_news1(inputs)
	if (locale === "es-ES") return es_es2_notifications_receivelist_news1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_receivelist_news1(inputs)
	if (locale === "fil") return fil_notifications_receivelist_news1(inputs)
	if (locale === "fr") return fr_notifications_receivelist_news1(inputs)
	if (locale === "it") return it_notifications_receivelist_news1(inputs)
	if (locale === "hu") return hu_notifications_receivelist_news1(inputs)
	if (locale === "nl") return nl_notifications_receivelist_news1(inputs)
	if (locale === "no") return no_notifications_receivelist_news1(inputs)
	if (locale === "pl") return pl_notifications_receivelist_news1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_receivelist_news1(inputs)
	if (locale === "pt") return pt_notifications_receivelist_news1(inputs)
	if (locale === "ro") return ro_notifications_receivelist_news1(inputs)
	if (locale === "fi") return fi_notifications_receivelist_news1(inputs)
	if (locale === "sv") return sv_notifications_receivelist_news1(inputs)
	if (locale === "vi") return vi_notifications_receivelist_news1(inputs)
	if (locale === "tr") return tr_notifications_receivelist_news1(inputs)
	if (locale === "cs") return cs_notifications_receivelist_news1(inputs)
	if (locale === "bg") return bg_notifications_receivelist_news1(inputs)
	if (locale === "ru") return ru_notifications_receivelist_news1(inputs)
	if (locale === "uk") return uk_notifications_receivelist_news1(inputs)
	if (locale === "ar") return ar_notifications_receivelist_news1(inputs)
	if (locale === "hi") return hi_notifications_receivelist_news1(inputs)
	if (locale === "th") return th_notifications_receivelist_news1(inputs)
	if (locale === "ja") return ja_notifications_receivelist_news1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_receivelist_news1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_receivelist_news1(inputs)
	return ko_notifications_receivelist_news1(inputs)
});
export { notifications_receivelist_news1 as "notifications.receiveList.news" }